var map = {
	"./announcement/sagas.js": 1032,
	"./app/sagas.js": 1033,
	"./auth/sagas.js": 1034,
	"./battle/sagas.js": 1037,
	"./business/sagas.js": 1038,
	"./effect/sagas.js": 1041,
	"./hedgieHouse/sagas.js": 1042,
	"./hedgies/sagas.js": 1050,
	"./item/sagas.js": 1051,
	"./journey/sagas.js": 1052,
	"./leaderboard/sagas.js": 1053,
	"./level/sagas.js": 1054,
	"./notification/sagas.js": 1055,
	"./resource/sagas.js": 1056,
	"./user/sagas.js": 1057
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1031;